module.exports = __webpack_public_path__ + "img/banner-intro.0a4ef355.jpg";